<mat-toolbar class="content-header">
  <!-- Section Titre -->
  <h1 class="page-title">
    <mat-icon class="title-icon">dashboard</mat-icon>

    {{ "dashboard.title" | translate }}

    <app-help [link]="helpLink" class="help-icon"></app-help>
  </h1>

  <span class="toolbar-spacer"></span>

  <!-- Section Navigation Date -->
  <div class="toolbar-section date-navigation">
    <div class="date-picker">
      <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_left" (click)="navigateDate(-1)">
      </lib-button>

      <app-date-picker *ngIf="!showEndDate" [startDate]="startDate" [min]="currentProject?.createdDate"
        (dateChanged)="onPickerChanged($event)" [hideTime]="true" [activity]="activitySignal()">
      </app-date-picker>

      <app-range-picker *ngIf="showEndDate" [startDate]="startDate" [endDate]="endDate"
        (change)="onRangePickerChanged($event)" [activity]="activitySignal()">
      </app-range-picker>

      <lib-button *ngIf="!showEndDate" size="small" color="none" icon="date_range" (click)="onShowEndChange()"
        tooltip="{{ 'dashboard.enable_date_range' | translate }}">
      </lib-button>

      <lib-button *ngIf="showEndDate" size="small" color="none" icon="close" (click)="onShowEndChange()">
      </lib-button>

      <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_right" (click)="navigateDate(1)"
        [disabled]="!canNavigateNext">
      </lib-button>
    </div>
  </div>

  <!-- Actions principales: same pill as on the tenant pages -->
  <lib-action-group>
    <lib-button *ngIf="this.userSignal().role.name !== 'user' && this.userSignal().role.name !== 'guest'"
      [icon]="'add_chart'" (click)="addWidgetEditor()" tooltip="{{ 'form.add' | translate }}">
    </lib-button>

    <lib-button customClass="refresh-btn" [icon]="'refresh'" [color]="'secondary'" (click)="refresh()"
      tooltip="{{ 'workflows.refresh' | translate }}">
    </lib-button>

    <!-- Menu Options -->
    <lib-button [matMenuTriggerFor]="menu" icon="more_horiz" color="muted" class="action-button menu-trigger"
      matTooltip="Options">
    </lib-button>
  </lib-action-group>

  <!-- Menus -->
  <mat-menu #menu="matMenu" class="modern-menu">
    <button mat-menu-item [matMenuTriggerFor]="shareMenu" class="menu-item">
      <mat-icon color="primary">share</mat-icon>
      <span>{{ "workflows.share" | translate }}</span>
    </button>

    <button *ngIf="this.userSignal().role.name !== 'guest'" mat-menu-item (click)="showReports()" class="menu-item">
      <mat-icon color="primary">visibility</mat-icon>
      <span>{{ "dashboard.show_reports" | translate }}</span>
    </button>

    <button mat-menu-item (click)="toggleFit()" class="menu-item">
      <mat-icon color="primary">{{ fit() ? 'fullscreen_exit' : 'fit_screen' }}</mat-icon>
      <span>{{ (fit() ? 'dashboard.fit_off' : 'dashboard.fit_on') | translate }}</span>
    </button>
  </mat-menu>

  <mat-menu #shareMenu="matMenu" class="modern-menu">
    <button mat-menu-item (click)="shareExport()" class="menu-item">
      <mat-icon color="primary">download</mat-icon>
      <span>{{ "dashboard.share.export" | translate }}</span>
    </button>

    <button mat-menu-item (click)="shareAccess()" class="menu-item">
      <mat-icon color="primary">public</mat-icon>
      <span>{{ "dashboard.share.public_access" | translate }}</span>
    </button>

    <button *ngIf="this.userSignal().role.name !== 'user' && this.userSignal().role.name !== 'guest'" mat-menu-item
      (click)="mailReports()" class="menu-item">
      <mat-icon color="primary">email</mat-icon>
      <span>{{ "dashboard.share.mail" | translate }}</span>
    </button>

    <button *ngIf="this.userSignal().role.name !== 'guest'" mat-menu-item (click)="mailReports(true)" class="menu-item">
      <mat-icon color="primary">notifications</mat-icon>
      <span>{{ "dashboard.reports.receive" | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>

<main class="content">
  <mat-drawer-container class="drawer-container" autosize>
    <!-- Écran de chargement -->
    <ng-container *ngIf="isLoading()">
      <div class="loading-overlay">
        <app-spinner [text]="'status.dashboard_loading' | translate">
        </app-spinner>
      </div>
    </ng-container>

    <!-- Dashboard avec widgets -->
    <ng-container *ngFor="let dashId of visibleDashboardIds()">
      <app-dashboard-panel *ngIf="dashboardStore.getDashboardById(dashId) as dashboard" [dashboard]="dashboard"
        [filters]="filters" [projects]="selectedProjects" [project]="currentProject" [units]="units"
        [refreshSignal]="refreshSignal" [exportSignal]="exportSignal" [fit]="fit()"
        [style.display]="currentDashboard?.id !== dashId ? 'none' : 'block'" class="dashboard-tab">
      </app-dashboard-panel>
    </ng-container>

    <!-- Dashboard sans widgets -->
    <ng-container
      *ngIf="currentProject && currentDashboard && (!currentDashboard.charts || currentDashboard.charts.length === 0) && !isLoading()">
      <lib-no-data [icon]="'dashboard'" [message]="'dashboard.empty.no_title'"
        [description]="'dashboard.empty.no_description'">
        <ng-container *ngIf="this.userSignal().role.name !== 'user' && this.userSignal().role.name !== 'guest'">
          <lib-button [icon]="'add_chart'" (click)="addWidgetEditor()" color="primary"
            text="{{ 'dashboard.manager.add' | translate }}">
          </lib-button>
        </ng-container>
      </lib-no-data>
    </ng-container>

    <!-- Pas de dashboard sélectionné -->
    <ng-container *ngIf="currentProject && !currentDashboard && !isLoading()">
      <lib-no-data [icon]="'view_quilt'" [message]="'dashboard.empty.no_dashboard_title'"
        [description]="'dashboard.empty.no_dashboard_description'">
        <ng-container *ngIf="this.userSignal().role.name !== 'user' && this.userSignal().role.name !== 'guest'">
          <lib-button [icon]="'dashboard'" (click)="addDashboard()" color="primary"
            text="{{ 'dashboard.manager.add' | translate }}">
          </lib-button>
        </ng-container>
      </lib-no-data>
    </ng-container>
  </mat-drawer-container>
</main>